<template>
    <div class="webGL">
        <canvas id="myCanvas" :width="width" :height="height"></canvas>
    </div>
</template>

<script>
import { vertex } from './vertex'
import { normal } from './normal'
export default {
  data () {
    return {
      /* canvas宽度和高度 -- 根据窗口大小动态赋值 */
      width: '',
      height: ''
    }
  },
  mounted () {
    /* 获取canvas的宽高 */
    const wrapDiv = document.querySelector('.webGL')
    this.width = window.getComputedStyle(wrapDiv, null).getPropertyValue('width')
    this.height = window.getComputedStyle(wrapDiv, null).getPropertyValue('height')
    this.$nextTick(() => {
      this.draw3d()
    })
  },
  methods: {
    draw3d () {
      /* ============= Creating a canvas ================= */
      var canvas = document.getElementById('myCanvas')
      const gl = canvas.getContext('webgl')
      // 检测WebGL支持
      if (!gl) {
        console.error('浏览器不支持WebGL')
        return
      }

      // 顶点着色器
      let VSHADER_SOURCE =
    'attribute vec4 apos;\n' + // attribute声明vec4类型变量apos
    'attribute vec4 a_color;\n' + // attribute声明顶点颜色变量
    // 顶点法向量变量
    'attribute vec4 a_normal;\n' +
    // uniform声明平行光颜色变量
    'uniform vec3 u_lightColor;\n' +
    // 平行光方向
    'uniform vec3 u_lightDirection;\n' +
    // uniform声明选中的物体
    'uniform int u_Clicked;\n' +
    'attribute float a_Face;\n' +
    // varying声明顶点颜色插值后变量
    'varying vec4 v_color;\n' +

    // uniform声明矩阵变量
    'uniform mat4 proj;\n' + // 模型矩阵
    'uniform mat4 mx;\n' + // 绕x轴旋转矩阵
    'uniform mat4 my;\n' + // 绕y轴旋转矩阵
    'uniform mat4 scale;\n' + // 缩放矩阵
    'uniform mat4 translate;\n' + // 平移矩阵

    'void main() {\n' +
    '  gl_Position = proj*translate*scale*mx*my*apos;\n' + // 设置点的位置 // 两个旋转矩阵、顶点齐次坐标连乘
    // 顶点法向量进行矩阵变换，然后归一化
    '  vec3 normal = normalize((mx*my*a_normal).xyz);\n' +
    // 计算平行光方向向量和顶点法向量的点积
    '  float dot = max(dot(u_lightDirection, normal), 0.0);\n' +
    // 计算反射后的颜色
    // '  vec4 a_color = vec4(0.0,1.0,1.0,1);\n' +
    '  vec3 reflectedLight = u_lightColor * a_color.rgb * dot;\n' +
    // 环境光
    '  vec3 u_AmbientLight = vec3(0.3,0.3,0.3);\n' +
    '  vec3 ambient = u_AmbientLight * a_color.rgb;\n' +
    // 颜色插值计算
    '  int face = int(a_Face);\n' +
    '  vec3 color = (face == u_Clicked) ? vec3(1.0)*u_lightColor* dot : reflectedLight;\n' +
    '  if(u_Clicked == 100){\n' +
    '    v_color = vec4(color + ambient,a_Face/255.0);\n' +
    '  }else{\n' +
    '    v_color = vec4(color + ambient, a_color.a);\n' +
    '  }\n' +
    '}\n'

    // 片元着色器
      let FSHADER_SOURCE =
    'precision mediump float;\n' + // 所有float类型数据的精度是lowp
    'varying vec4 v_color;\n' + // 接收顶点着色器中v_color数据
    'void main() {\n' +
    '  gl_FragColor = v_color;\n' + // 插值后颜色数据赋值给对应的片元
    '}\n'

      var program = initShader(gl, VSHADER_SOURCE, FSHADER_SOURCE)

      if (!program) {
        console.log('program is Null')
      }

      /**
     * 从program对象获取相关的变量
     * attribute变量声明的方法使用getAttribLocation()方法
     * uniform变量声明的方法使用getUniformLocation()方法
     **/
      var aposLocation = gl.getAttribLocation(program, 'apos')
      // eslint-disable-next-line camelcase
      var a_color = gl.getAttribLocation(program, 'a_color')
      // eslint-disable-next-line camelcase
      var a_normal = gl.getAttribLocation(program, 'a_normal')
      // eslint-disable-next-line camelcase
      var u_lightColor = gl.getUniformLocation(program, 'u_lightColor')
      // eslint-disable-next-line camelcase
      var u_lightDirection = gl.getUniformLocation(program, 'u_lightDirection')
      // eslint-disable-next-line camelcase
      var u_Clicked = gl.getUniformLocation(program, 'u_Clicked')
      // eslint-disable-next-line camelcase
      var a_Face = gl.getAttribLocation(program, 'a_Face')

      /** 从program对象获得旋转矩阵变量proj、mx、my、scale、translate变量**/
      var uniformProj = gl.getUniformLocation(program, 'proj')
      var mx = gl.getUniformLocation(program, 'mx')
      var my = gl.getUniformLocation(program, 'my')
      var scale = gl.getUniformLocation(program, 'scale')
      var translate = gl.getUniformLocation(program, 'translate')

      // Initialize selected surface
      gl.uniform1i(u_Clicked, -1)

      /* 设置旋转、缩放、平移默认值 */
      var anglex = 60
      var angley = 0
      var scaleValue = 1.2
      var transValueX = 0
      var transValueY = 0

      /**
     * 给平行光传入颜色和方向数据，RGB(1,1,1),单位向量(x,y,z)
     **/
      gl.uniform3f(u_lightColor, 1.0, 1.0, 1.0)
      gl.uniform3f(u_lightDirection, 1, 1, 1)

      /* 创建正交投影 */
      gl.viewport(0, 0, canvas.clientWidth, canvas.clientHeight)
      var projectMat = createOrtho(-canvas.clientWidth * 5, canvas.clientWidth * 5, -canvas.clientHeight * 5, canvas.clientHeight * 5, -1000.0, 1000.0)
      gl.uniformMatrix4fv(uniformProj, false, projectMat)
      /**
     * 给平行光传入颜色和方向数据，RGB(1,1,1),单位向量(x,y,z)
     **/
      gl.uniform3f(u_lightColor, 1.0, 1.0, 1.0)
      gl.uniform3f(u_lightDirection, 1.0, 0.0, 1.0)

      // 添加鼠标点击事件
      initEventHandles()
      // 添加滑轮缩放事件
      canvas.addEventListener('wheel', onMouseWheel, false)
      canvas.oncontextmenu = function () {
        return false
      }

      draw()

      // 声明渲染函数
      function draw () {
        gl.clear(gl.COLOR_BUFFER_BIT) // 清空画布上一帧图像
        // 旋转角度
        var sinx = Math.sin(anglex)// x轴旋转角度正弦值
        var cosx = Math.cos(anglex)// x轴旋转角度余弦值
        var siny = Math.sin(angley)// y轴旋转角度正弦值
        var cosy = Math.cos(angley)// y轴旋转角度余弦值
        // y轴旋转矩阵
        var mxArrx = new Float32Array([1, 0, 0, 0, 0, cosx, -sinx, 0, 0, sinx, cosx, 0, 0, 0, 0, 1])
        // y轴旋转矩阵
        var myArry = new Float32Array([cosy, 0, -siny, 0, 0, 1, 0, 0, siny, 0, cosy, 0, 0, 0, 0, 1])
        // 把数据mxArr传递给着色器旋转矩阵变量mx,my
        gl.uniformMatrix4fv(mx, false, mxArrx)
        gl.uniformMatrix4fv(my, false, myArry)

        // 缩放矩阵
        var scaleArry = new Float32Array([scaleValue, 0.0, 0.0, 0.0, 0.0, scaleValue, 0.0, 0.0, 0.0, 0.0, scaleValue, 0.0, 0.0, 0.0, 0.0, 1.0])
        // 把缩放数据传递给缩放矩阵
        gl.uniformMatrix4fv(scale, false, scaleArry)

        // 平移矩阵
        var translateArry = new Float32Array([1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, transValueX, transValueY, 0, 1])
        // 把平移数据传递给缩放矩阵
        gl.uniformMatrix4fv(translate, false, translateArry)

        requestAnimationFrame(draw)
        /** 执行绘制命令**/
        gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT)

        initVertexBuffers()
      }

      function initShader (gl, vshader, fshader) {
        var program = createProgram(gl, VSHADER_SOURCE, FSHADER_SOURCE)
        if (!program) {
          console.log('create program failed')
          return false
        }
        gl.useProgram(program) // 将着色器程序设置为有效
        return program
      }

      function createProgram (gl, vshader, fshader) {
        // 创造着色器对象
        let vertexShader = loadShader(gl, gl.VERTEX_SHADER, vshader)
        let fragmentShader = loadShader(gl, gl.FRAGMENT_SHADER, fshader)
        if (!vertexShader || !fragmentShader) {
          return null
        }

        // 创造 program 对象
        let program = gl.createProgram()
        if (!program) {
          return null
        }

        // 绑定着色器与program
        gl.attachShader(program, vertexShader)
        gl.attachShader(program, fragmentShader)

        // 连接program
        gl.linkProgram(program)

        // 检查连接结果
        let linked = gl.getProgramParameter(program, gl.LINK_STATUS)
        if (!linked) {
          let error = gl.getProgramInfoLog(program)
          console.log('连接 program失败: ' + error)
          gl.deleteProgram(program)
          gl.deleteShader(fragmentShader)
          gl.deleteShader(vertexShader)
          return null
        }
        return program
      }

      function loadShader (gl, type, source) {
        // 创建着色器
        let shader = gl.createShader(type)
        if (shader == null) {
          console.log('创建着色器失败')
          return null
        }

        // Set the shader program
        gl.shaderSource(shader, source)

        // 编译着色器
        gl.compileShader(shader)

        // 检查编译结果
        let compiled = gl.getShaderParameter(shader, gl.COMPILE_STATUS)
        if (!compiled) {
          let error = gl.getShaderInfoLog(shader)
          console.error('编译着色器失败: ' + error)
          gl.deleteShader(shader)
          return null
        }

        return shader
      }

      function createOrtho (left, right, top, buttom, near, far) {
        var width = right - left
        var height = buttom - top
        var depth = far - near
        var ortho = new Float32Array([
          2 / width, 0, 0, 0,
          0, 2 / height, 0, 0,
          0, 0, -2 / depth, 0,
          -(left + right) / width, -(top + buttom) / height, -(near + far) / depth, 1
        ])
        return ortho
      }

      function onMouseWheel (event) {
        event.preventDefault()
        // 缩放比例
        var ratio = 0.02
        // 当滚轮向上滑动时
        if (event.wheelDelta > 0) {
          scaleValue += ratio
        }
        // 当滚轮向下滑动时
        if (event.wheelDelta < 0) {
          scaleValue -= ratio
        }
      }

      function initEventHandles () {
        // 鼠标左键状态
        var draggingLeft = false
        // 鼠标右键状态
        var draggingRight = false

        canvas.onmousedown = function (ev) { // Mouse is pressed
          ev.preventDefault()

          var lastX = 0
          var lastY = 0

          var x = ev.clientX
          var y = ev.clientY
          var rect = ev.target.getBoundingClientRect()
          if (rect.left <= x && x < rect.right && rect.top <= y && y < rect.bottom) {
          // If Clicked position is inside the <canvas>, update the selected surface
          // eslint-disable-next-line camelcase
            var x_in_canvas = x - rect.left
            // eslint-disable-next-line camelcase
            var y_in_canvas = rect.bottom - y
            var face = checkFace(x_in_canvas, y_in_canvas)
            console.log(face)
            gl.uniform1i(u_Clicked, face) // Pass the surface number to u_PickedFace
            draw()
          }

          lastX = x
          lastY = y

          // 控制鼠标左键
          if (ev.button === 0) {
            draggingLeft = true
          }

          // 控制鼠标右键
          if (ev.button === 2) {
            draggingRight = true
          }

          canvas.onmousemove = function (ev) {
            ev.preventDefault()

            var x = ev.clientX
            var y = ev.clientY

            // 鼠标左键按下
            if (draggingLeft) {
            // 旋转比例--速度
              var factor = 0.008
              var dx = factor * (x - lastX)
              var dy = factor * (y - lastY)

              // 限制 x轴的旋转角度 -90 --- 90
              // anglex = Math.max(Math.min(anglex + dy, 90.0), -90.0)
              anglex -= dy
              angley += dx
            }

            // 鼠标右键按下
            if (draggingRight) {
            // 移动比例--速度
              var factorRight = 0.8
              var dxR = factorRight * (x - lastX)
              var dyR = factorRight * (y - lastY)

              transValueX += dxR
              transValueY -= dyR
            }

            lastX = x
            lastY = y
          }
        }

        canvas.onmouseup = function (ev) {
          ev.preventDefault()
          draggingLeft = false
          draggingRight = false
        }

        canvas.onmouseleave = function (ev) {
          ev.preventDefault()
          draggingLeft = false
          draggingRight = false
        }
      }

      // 选择物体
      function checkFace (x, y) {
        // 获取点击位置的像素
        var pixels = new Uint8Array(4) // Array for storing the pixel value
        gl.uniform1i(u_Clicked, 100) // Draw by writing surface number into alpha value
        draw()
        // Read the pixel value of the clicked position. pixels[3] is the surface number
        gl.readPixels(x, y, 1, 1, gl.RGBA, gl.UNSIGNED_BYTE, pixels)
        // gl.uniform1i(u_Clicked, -1);
        draw()
        return pixels[3]
      }

      function initVertexBuffers () {
        var vertexData = new Float32Array(vertex)

        /** 创建顶点颜色数组colorData **/
        /* 颜色数据 */
        var colorData = []
        for (let i = 0; i < vertex.length; i += 3) {
          colorData.push('0.0')
          colorData.push('1.0')
          colorData.push('1.0')
        }
        colorData = new Float32Array(colorData)
        /**
    *顶点法向量数组normalData
    **/
        var normalData = new Float32Array(normal)

        /* 顶点面数组 */
        var facesData = []
        for (let i = 0; i < vertex.length; i++) {
          facesData.push('1')
        }
        facesData = new Uint8Array(facesData)

        /**
         创建顶点缓冲区buffer，传入顶点位置数据data
        **/
        var buffer = gl.createBuffer()
        gl.bindBuffer(gl.ARRAY_BUFFER, buffer)
        gl.bufferData(gl.ARRAY_BUFFER, vertexData, gl.STATIC_DRAW)
        gl.vertexAttribPointer(aposLocation, 3, gl.FLOAT, false, 0, 0)
        gl.enableVertexAttribArray(aposLocation)

        /**
         创建颜色缓冲区colorBuffer，传入顶点颜色数据colorData
        **/
        var colorBuffer = gl.createBuffer()
        gl.bindBuffer(gl.ARRAY_BUFFER, colorBuffer)
        gl.bufferData(gl.ARRAY_BUFFER, colorData, gl.STATIC_DRAW)
        gl.vertexAttribPointer(a_color, 3, gl.FLOAT, false, 0, 0)
        gl.enableVertexAttribArray(a_color)

        /**
        创建法向量缓冲区normalBuffer，传入顶点法向量数据normalData
       **/
        var normalBuffer = gl.createBuffer()
        gl.bindBuffer(gl.ARRAY_BUFFER, normalBuffer)
        gl.bufferData(gl.ARRAY_BUFFER, normalData, gl.STATIC_DRAW)
        gl.vertexAttribPointer(a_normal, 3, gl.FLOAT, false, 0, 0)
        gl.enableVertexAttribArray(a_normal)

        /**
        创建面缓冲区facesBuffer，传入顶点法向量数据facesData
       **/
        var facesBuffer = gl.createBuffer()
        gl.bindBuffer(gl.ARRAY_BUFFER, facesBuffer)
        gl.bufferData(gl.ARRAY_BUFFER, facesData, gl.STATIC_DRAW)
        gl.vertexAttribPointer(a_Face, 1, gl.UNSIGNED_BYTE, false, 0, 0)
        gl.enableVertexAttribArray(a_Face)

        /** 执行绘制之前，一定要开启深度测试，以免颜色混乱**/
        gl.enable(gl.DEPTH_TEST)

        const n = vertexData.length / 3
        gl.drawArrays(gl.TRIANGLES, 0, n)
      }
    }
  }
}
</script>
<style scoped>
.webGL {
    background-color: #fff;
    color: #333;
    text-align: center;
    height: 400px;
    margin-bottom: 32px;
  }
</style>



// WEBPACK FOOTER //
// src/components/WebGLView/index.vue